import React, { useState } from "react";
import "../component/modalAddTreatment.css";

import { createPortal } from "react-dom";

const ModalAddTreatment = ({
  isShowModal,
  onCloseModal,
  onSubmitData,
  treatmentObject,
}) => {
  const [treatmentData, setTreatmentData] = useState(treatmentObject);

  const closeModal = () => {
    setTreatmentData({
      doctor_treatment_id: "",
      doctor_treatment_name: "",
      doctor_treatment_price: 0,
    });
    onCloseModal();
  };

  return createPortal(
    isShowModal && (
      <div className="modal-doctor-treatment-container">
        <div className="modal-doctor-treatment-content">
          <header className="modal-doctor-treatment-header">
            <h2 className="modal-doctor-treatment-header-title">Tambah Poli</h2>
            <button className="modal-header-close-button" onClick={closeModal}>
              &times;
            </button>
          </header>
          <main className="modal-doctor-treatment-main">
            <div className="form-group">
              <div className="input-title-label-container">
                <span className="input-title-label">Tindakan Medis Baru</span>
              </div>
              <div className="input-treatment-name-field-container">
                <input
                  type="text"
                  value={
                    treatmentData.doctor_treatment_name
                      ? treatmentData.doctor_treatment_name
                      : ""
                  }
                  onChange={(e) =>
                    setTreatmentData({
                      ...treatmentData,
                      doctor_treatment_name: e.target.value,
                    })
                  }
                  placeholder="Masukkan nama tindakan"
                />
              </div>
              <div className="input-treatment-name-field-container">
                <input
                  type="text"
                  value={
                    treatmentData.doctor_treatment_price
                      ? treatmentData.doctor_treatment_price
                      : ""
                  }
                  onChange={(e) =>
                    setTreatmentData({
                      ...treatmentData,
                      doctor_treatment_price: e.target.value,
                    })
                  }
                  placeholder="Masukkan nama tindakan"
                />
              </div>
            </div>
          </main>
          <footer className="modal-doctor-treatment-footer">
            <button className="modal-close-button" onClick={closeModal}>
              Batal
            </button>
            <button
              className="modal-submit-button"
              onClick={() => {
                const isEditData = treatmentData.doctor_treatment_id !== "";
                onSubmitData(treatmentData, isEditData);
                closeModal();
              }}
            >
              Submit
            </button>
          </footer>
        </div>
      </div>
    ),
    document.getElementById("modal")
  );
};

export default ModalAddTreatment;
